// extracted by mini-css-extract-plugin
export default {"StepsWrapper":"styles_StepsWrapper_nWSMw","StepsText":"styles_StepsText_ow48z"};